import { useCallback } from 'react';
import { Card, Stat, EmptyState, PageHeader } from '@/components/ui';
import { Chart } from '@/components/ui/Chart';
import { Icon } from '@/components/ui/Icon';
import { superApi } from '@/shared/api/superApi';
import { useResource } from '@/shared/hooks/useResource';

interface DashData {
  kpis: { tenants: number; active_tenants: number; mrr_30d: number; active_calls: number; calls_today: number; failed_today: number; asr: number };
  overdue_invoices: { id: number; tenant_id: number; number: string; amount_cents: number }[];
}

export function SuperDashboard() {
  const fetcher = useCallback(() => superApi.dashboard().then((d) => d as DashData), []);
  const { data, loading, error, reload } = useResource(fetcher);

  if (error && !data) {
    return (
      <div style={{ padding: 'var(--gap)' }}>
        <Card>
          <EmptyState
            icon="warn"
            title="שגיאה בטעינת הדשבורד"
            description="לא ניתן היה לטעון את נתוני הספק מהשרת."
            action={<button type="button" className="btn primary" onClick={reload}>נסה שוב</button>}
          />
        </Card>
      </div>
    );
  }
  if (loading || !data?.kpis) return <div style={{ padding: 'var(--gap)' }}><Card>טוען…</Card></div>;

  return (
    <div className="stack" style={{ padding: 'var(--gap)' }}>
      <PageHeader title="דשבורד ספק" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 'var(--gap)' }}>
        <Stat label="לקוחות" value={data.kpis.tenants} icon={<Icon name="users" size={14} />} />
        <Stat label="פעילים" value={data.kpis.active_tenants} icon={<Icon name="ok" size={14} color="var(--ok)" />} />
        <Stat label="MRR (30 ימים)" value={`₪${data.kpis.mrr_30d.toFixed(0)}`} icon={<Icon name="chart" size={14} />} />
        <Stat label="שיחות פעילות" value={data.kpis.active_calls} icon={<Icon name="phone" size={14} />} />
        <Stat label="שיחות היום" value={data.kpis.calls_today} />
        <Stat label="ASR" value={`${data.kpis.asr}%`} icon={<Icon name="bolt" size={14} />} />
      </div>

      <Card title="חשבוניות באיחור">
        {data.overdue_invoices.length === 0 ? (
          <p style={{ color: 'var(--muted)' }}>אין חשבוניות באיחור.</p>
        ) : (
          <table style={{ width: '100%' }}>
            <tbody>
              {data.overdue_invoices.map((inv) => (
                <tr key={inv.id}>
                  <td>{inv.number}</td>
                  <td>tenant #{inv.tenant_id}</td>
                  <td>₪{(inv.amount_cents / 100).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
